<template>
  <div class="uni-input-checkbox">
    <slot></slot>
    <label :for="id">
      <div>
        <div class="checkbox">
          <div class="box">
            <svg viewBox="0 0 24 24">
              <path fill="none" stroke="white" d="M1.73,12.91 8.1,19.28 22.79,4.59">
              </path>
            </svg>
          </div>
          <div class="hover-effect"></div>
        </div>
        <span v-if="label" class="uni-body uni-label">
          {{ label }}
        </span>
      </div>
    </label>
  </div>
</template>

<script>
  export default {
    name: "UniInputCheckbox",
    props: {
      label: {
        type: String
      },
      id: {
        type: [String, Number],
      },
    },
  }
</script>

<style scoped lang="scss">

  .uni-label {
    margin-left: var(--s-xs);
    margin-bottom:0;
  }

  .uni-input-checkbox {
    margin: var(--s-s) 0 var(--s-m) 0;
    label {
      cursor: pointer;
      margin: 0;
      > div {
        display: inline-flex;
        align-items: center;
      }
    }
    input {
      opacity: 0;
      height: 0px;
      position: absolute;
    }
    input:focus + label {
      .radio {
        .hover-effect {
          opacity: .6;
        }
      }
    }
    input:checked + label {
      .checkbox {
        > .box {
          border: 2px solid var(--color-primary);
          background: var(--color-primary);
          path {
            stroke-dashoffset: 0;
          }
        }
      }
    }
    .checkbox {
      > .box {
        position: relative;
        z-index: 2;
        margin-left: 2px;
        margin-top: 2px;
        height: 20px;
        width: 20px;
        border: 2px solid var(--color-grey-light-1);
        border-radius: 4px;
        transition: var(--transition-quick);
        path {
          stroke-width: 3px;
          stroke-dashoffset: 30;
          stroke-dasharray: 30;
          transition: var(--transition-quick);
        }
        &:before {
          content: "";
          position: absolute;
          height: 10px;
          width: 10px;
          border-radius: 8px;
          background: var(--color-primary);
          margin-top: 3px;
          margin-left: 3px;
          transition: var(--transition-quick);
          transform: scale(0);
        }
      }
      &:hover {
        > .hover-effect {
          opacity: .3;
        }
      }
      > .hover-effect {
        position: absolute;
        z-index: 1;
        height: 32px;
        width: 32px;
        margin-top: -26px;
        margin-left: -4px;
        border-radius: var(--s-l);
        background: var(--color-primary-light-1);
        opacity: 0;
        transition: var(--transition-quick);
      }
    }
  }

</style>
